import {computed, inject, Injectable, Signal} from '@angular/core';

import {RequestTools} from '@selpia/shared/data-access';
import {Dimension, DimensionLevel, Measure} from '@selpia/shared/models';

import {AppConfigStore} from '../state/app-config.store';
import {ReportConfig, TileTable} from '../models';

@Injectable({
  providedIn: 'root',
})
export class AppConfigFacade {
  readonly #store = inject(AppConfigStore);

  readonly isLoading: Signal<boolean> = RequestTools.isSignalPending(this.#store.loadingStatus);
  readonly dimensions: Signal<Dimension[] | undefined> = this.#store.dimensions;

  readonly initialFocusDimensionLevel: Signal<DimensionLevel | undefined> = this.#store.initialFocusDimensionLevel;
  readonly isAIAssistantEnabled: Signal<boolean | undefined> = this.#store.isAIAssistantEnabled;

  readonly initialDate: Signal<Date | undefined> = this.#store.initialDate;

  readonly initialPeriod: Signal<string | undefined> = this.#store.initialPeriod;
  readonly periods: Signal<string[]> = this.#store.periods;

  readonly focusMeasures: Signal<Measure[]> = this.#store.focusMeasures;
  readonly initialFocusMeasure: Signal<Measure | undefined> = this.#store.initialFocusMeasure;

  readonly growthMeasureLabel: Signal<string | undefined> = this.#store.growthMeasureLabel;

  readonly titleTemplate: Signal<string | undefined> = computed(() => this.#store.gridTitle()?.title);

  readonly dateFormat: Signal<string | undefined> = computed(() => this.#store.gridTitle()?.dateFormat);

  readonly mainTagFormat: Signal<string | undefined> = computed(() => this.#store.mainTag()?.format);

  readonly tileTable: Signal<TileTable | undefined> = this.#store.tileTable;

  readonly reportConfig: Signal<ReportConfig | undefined> = this.#store.report;

  readonly dashboardTitle: Signal<string> = this.#store.dashboardTitle;

  readonly highlightStrategies: Signal<string[]> = this.#store.highlightStrategies;

  load(allMeasures: Measure[]): void {
    this.#store.loadConfig(allMeasures);
  }
}
